import type { Moment } from "moment-timezone";

import { getNowInPreferredTimezone } from "helpers/dateTimeHelper";

export const DEFAULT_QUOTING_DEADLINE_HOURS = 24;
export const DEFAULT_CONFIRMATION_TIME_DAYS = 7;

export type TimingSettings = {
  use_default_confirmation_time: boolean;
  quoting_deadline_minimum_time_minutes: number;
  default_confirmation_time_days: number;
};

export type ProviderDeadlineValue = {
  date: string;
  time: string;
};

export function getDefaultQuotingDeadline(now: Moment = getNowInPreferredTimezone()): ProviderDeadlineValue {
  const deadline = now.clone().add(DEFAULT_QUOTING_DEADLINE_HOURS, "hours");
  return {
    date: deadline.format("YYYY-MM-DD"),
    time: deadline.format("HH:mm:ss"),
  };
}

type GetDefaultConfirmationDeadlineOptions = {
  useSettingDefault?: boolean;
  now?: Moment;
};

export function getDefaultConfirmationDeadline(
  settings: TimingSettings,
  { useSettingDefault = true, now = getNowInPreferredTimezone() }: GetDefaultConfirmationDeadlineOptions = {},
): ProviderDeadlineValue {
  const daysToAdd = useSettingDefault ? settings.default_confirmation_time_days : DEFAULT_CONFIRMATION_TIME_DAYS;
  const confirmation = now.clone().add(daysToAdd, "days");
  return {
    date: confirmation.format("YYYY-MM-DD"),
    time: confirmation.format("HH:mm:ss"),
  };
}
